import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ShoppingGuidePage from "@/pages/article/kaspreadsheet-shopping-guide/page";
import ProductResearchPage from "@/pages/article/kaspreadsheet-product-research/page";
import ComparisonPage from "@/pages/article/kaspreadsheet-vs-traditional/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/kaspreadsheet-shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/kaspreadsheet-product-research",
    element: <ProductResearchPage />,
  },
  {
    path: "/kaspreadsheet-vs-traditional",
    element: <ComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;